import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ErrorPageContainer, ErrorCode, ErrorMessage, ErrorActionButton } from '../style';

const NotAuthorized = () => {
    const navigate = useNavigate();

    return (
        <ErrorPageContainer>
            <ErrorCode>403</ErrorCode>
            <ErrorMessage>You do not have permission to view this page.</ErrorMessage>
            <ErrorActionButton>
                <Button type="primary" size="large" onClick={() => navigate('/')}>
                    Go Home
                </Button>
            </ErrorActionButton>
        </ErrorPageContainer>
    );
};

export default NotAuthorized;
